<template>
  <div style="width:100%;">
    <hi-row class="ui-text py-3 sec-title2" separator>Active Users</hi-row>
    <hi-row
      v-for="user in activatedUsers"
      :key="user.id"
      flex
      separator
      class="active-user-block"
    >
      <v-col cols="3"
        ><hi-avatar :uid="user.id" :show-name="false"></hi-avatar
      ></v-col>
      <v-col cols="6">
        <div class="display-name">{{ user.name }} {{ user.surname }}</div>
        <div>{{ user.email }}</div>
        <div class="ui-text">
          Activated on {{ user.dateActivated | timestamp }}
        </div>
      </v-col>
    </hi-row>
    <hi-row
      class="ui-text py-3 sec-title2"
      separator
      v-if="pendingUsers.length"
    >
      Pending Users
    </hi-row>
    <hi-row
      v-for="user in pendingUsers"
      :key="user.id"
      flex
      separator
      class="active-user-block"
    >
      <v-col cols="3">
        <div class="display-name">{{ user.name }} {{ user.surname }}</div>
      </v-col>
      <v-col cols="6">
        <div>{{ user.email }}</div>
        <div class="ui-text">Invited on {{ user.dateInvited | timestamp }}</div>
      </v-col>
      <v-col cols="3">
        <div class="text-right">
          <span class="ui-text-clickable" @click="resendInvitation(user.id)"
            >Resend
          </span>
        </div>
      </v-col>
    </hi-row>

    <hi-row right style="padding-top:30px">
      <span @click="invitationOpened = true" class="ui-text-clickable"
        >Invite New User</span
      >
    </hi-row>
    <!--    //////////////////// dialog //////////////////////////////////-->
    <hi-dialog
      title="Invite New User"
      v-model="invitationOpened"
      @submit="inviteUser"
      submit-txt="Invite"
    >
      <v-form v-model="valid" ref="inviteForm">
        <hi-row flex>
          <v-col cols="6">
            <v-text-field
              v-model="inviteName"
              label="First Name"
              :rules="[rules.required]"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="inviteSurname"
              label="Surname"
            ></v-text-field>
          </v-col>
        </hi-row>
        <hi-row flex>
          <v-col cols="12">
            <v-text-field
              v-model="inviteEmail"
              label="Email Address"
              :rules="[rules.required, rules.email]"
            ></v-text-field>
          </v-col>
        </hi-row>
      </v-form>
      <div v-if="inviteErr" class="error-block">
        {{ inviteErr }}
      </div>
    </hi-dialog>
  </div>
</template>

<script>
import { collections } from "@/db";
import { api } from "@/api";
import HiAvatar from "@/components/HiAvatar";
import HiRow from "@/components/scaffold/HiRow";
import Validator from "@/hive/Validator";
import HiDialog from "@/components/HiDialog";
import hive from "@/hive";

export default {
  name: "users",
  components: { HiDialog, HiRow, HiAvatar },
  data() {
    return {
      users: null,
      valid: false,
      tab: null,
      inviteEmail: "",
      inviteName: "",
      inviteSurname: "",
      rules: {
        required: value => !!value || "Required.",
        email: value => {
          // const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return Validator.email(value) || "Invalid e-mail.";
        }
      },
      invitationOpened: false,
      inviteErr: null
    };
  },
  firestore: {
    users: collections.users
  },
  methods: {
    inviteUser() {
      if (this.valid) {
        api.users
          .createUser(
            this.inviteEmail,
            "google",
            this.inviteName,
            this.inviteSurname
          )
          .then(() => {
            this.inviteEmail = "";
            this.resetForm();
          })
          .catch(error => {
            console.log(error);
            this.inviteErr = error.message;
          });
      }
    },
    async resendInvitation(id) {
      console.log("uid", id);
      const result = await api.users.resendInvitation(id);
      console.log(result);
      if (result.ok) {
        hive.toastSuccess("Invitation sent!");
      }
      if (result.error) {
        hive.toastError("Invitation email error: " + result.error);
      }
    },
    resetForm() {
      this.$refs.inviteForm.reset();
      this.inviteErr = null;
      this.invitationOpened = false;
    }
  },

  computed: {
    activatedUsers() {
      if (!this.users) return null;
      const arr = [];
      this.users.forEach(user => {
        if (user.dateActivated) {
          arr.push(user);
        }
      });
      return arr;
    },
    pendingUsers() {
      if (!this.users) return null;
      const arr = [];
      this.users.forEach(user => {
        console.log("users", user);
        if (!user.dateActivated) {
          arr.push(user);
        }
      });
      return arr;
    }
  }
};
</script>

<style scoped lang="scss">
th {
  background-color: $light3;
  color: #51504f;
  font-size: small;
  text-align: left;
}
tr:hover {
  background-color: white;
}
.active-user-block {
  transition: background-color 0.5s;
}
.active-user-block:hover {
  background-color: rgba(255, 255, 255, 0.5);
}
</style>
